import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import { getFileExtension, formatBytes, saveFile } from "../Utils";
import ImageViewerView from "../image_viewer/ImageViewerView";
import { rotateFlipImage } from "../ImageHelper/ImageRenderer";

function FlipImagesListImagesScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, transform etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //is rotating
  const [isRotating, setIsRotating] = useState(false);

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnail
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = () => {
    //loop
    //read files
    //get thumbnails
    for (let i = 0; i < selectedFiles.length; i++) {
      //selected file
      const selectedFile = selectedFiles[i];
      //path image file
      const key = String(selectedFile.path);
      //set image
      setFilesInfo((prevDictionary) => ({
        ...prevDictionary,
        [key]: {
          ...filesInfo[key],
          state: AppState.LOADED,
          thumbnail: URL.createObjectURL(selectedFile),
          message: "",
          mimeType: selectedFile.type,
          transform: {
            rotate: 0, //in degree
            flipV: false,
            flipH: false,
          },
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
          rotated_blob: null,
          rotated_size: 0,
        },
      }));
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //show preview
          setShowImagePreview({
            ...showImagePreview,
            preview: true,
            file:
              String(item.path) in filesInfo
                ? filesInfo[String(item.path)].rotated_blob === null
                  ? item
                  : filesInfo[String(item.path)].rotated_blob
                : item,
          });
        }}
      >
        {/* Flex container left image right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* rotation button groups */}
          <div
            className="justify-content-center align-items-center text-center btn-group-vertical my-auto"
            data-toggle="buttons"
          >
            {/* rotate clockwise */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //rotate clockwise
                //change angle +90 degree
                //key
                const key = String(item.path);
                //set rotation
                setFilesInfo((prevDictionary) => ({
                  ...prevDictionary,
                  [key]: {
                    ...filesInfo[key],
                    transform: {
                      ...filesInfo[key].transform,
                      rotate: filesInfo[key].transform.rotate + 90,
                    },
                  },
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-clockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
              </svg>
            </button>

            {/* Rotate counter clockwise Button */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //rotate counter clockwise
                //change angle -90 degree
                //key
                const key = String(item.path);
                //set rotation
                setFilesInfo((prevDictionary) => ({
                  ...prevDictionary,
                  [key]: {
                    ...filesInfo[key],
                    transform: {
                      ...filesInfo[key].transform,
                      rotate: filesInfo[key].transform.rotate - 90,
                    },
                  },
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-counterclockwise"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
                />
                <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466" />
              </svg>
            </button>

            {/* Flip horizontally button */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //flip horizontal
                //key
                const key = String(item.path);
                //set rotation
                setFilesInfo((prevDictionary) => ({
                  ...prevDictionary,
                  [key]: {
                    ...filesInfo[key],
                    transform: {
                      ...filesInfo[key].transform,
                      flipH:
                        (filesInfo[key].transform.rotate / 90) % 2 === 0
                          ? filesInfo[key].transform.flipH
                            ? false
                            : true
                          : filesInfo[key].transform.flipH,
                      flipV:
                        (filesInfo[key].transform.rotate / 90) % 2 !== 0
                          ? filesInfo[key].transform.flipV
                            ? false
                            : true
                          : filesInfo[key].transform.flipV,
                    },
                  },
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrows"
                viewBox="0 0 16 16"
              >
                <path d="M1.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L2.707 7.5h10.586l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.293 8.5H2.707l1.147 1.146a.5.5 0 0 1-.708.708z" />
              </svg>
            </button>

            {/* Flip vertically button */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();

                //flip vertical
                //key
                const key = String(item.path);
                //set rotation
                setFilesInfo((prevDictionary) => ({
                  ...prevDictionary,
                  [key]: {
                    ...filesInfo[key],
                    transform: {
                      ...filesInfo[key].transform,
                      flipH:
                        (filesInfo[key].transform.rotate / 90) % 2 !== 0
                          ? filesInfo[key].transform.flipH
                            ? false
                            : true
                          : filesInfo[key].transform.flipH,
                      flipV:
                        (filesInfo[key].transform.rotate / 90) % 2 === 0
                          ? filesInfo[key].transform.flipV
                            ? false
                            : true
                          : filesInfo[key].transform.flipV,
                    },
                  },
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrows-vertical"
                viewBox="0 0 16 16"
              >
                <path d="M8.354 14.854a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 13.293V2.707L6.354 3.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 2.707v10.586l1.146-1.147a.5.5 0 0 1 .708.708z" />
              </svg>
            </button>
          </div>
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="image_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                  transform: `rotate(${String(item.path) in filesInfo ? filesInfo[String(item.path)].transform.rotate : 0}deg) scaleX(${
                    String(item.path) in filesInfo
                      ? filesInfo[String(item.path)].transform.flipH
                        ? -1
                        : 1
                      : 1
                  }) scaleY(${String(item.path) in filesInfo ? (filesInfo[String(item.path)].transform.flipV ? -1 : 1) : 1})`,
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size: {formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "PROCESSED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Image Index */}
            <div className="px-2 fs-6 text-body-secondary">
              {`Index: ${index + 1}`}
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          <div
            className="position-absolute justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            {/* Download button */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //check
                  if (String(item.path) in filesInfo === true) {
                    //blob
                    const blob = filesInfo[String(item.path)].rotated_blob;
                    //save
                    await saveFile(blob, filesInfo[String(item.path)].name);
                  }
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-sm-3 ms-2 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show image preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Flip Images"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Rotate buttpons */}
              <div className="ms-4 me-4 mt-5">
                <div>
                  <label
                    className="fs-4 text-dark"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Rotate/Flip all images"
                  >
                    Quick Actions:
                  </label>
                </div>

                {/* All images rotation button */}
                <div className="d-flex mt-4">
                  <button
                    className="btn btn-outline-primary"
                    onClick={(e) => {
                      //rotate all images
                      //cw
                      let updatedFilesInfo = {};
                      //iterate dictionary
                      Object.keys(filesInfo).forEach((item) => {
                        //add to new dictionary
                        updatedFilesInfo = {
                          ...updatedFilesInfo,
                          [item]: {
                            ...filesInfo[item],
                            transform: {
                              ...filesInfo[item].transform,
                              rotate: filesInfo[item].transform.rotate + 90,
                            },
                          },
                        };
                      });

                      //set value
                      setFilesInfo(updatedFilesInfo);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-clockwise me-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                      />
                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Rotate Clockwise
                    </label>
                  </button>
                  <button
                    className="btn btn-outline-primary ms-2"
                    onClick={(e) => {
                      //rotate all pages
                      //ccw
                      let updatedFilesInfo = {};
                      //iterate dictionary
                      Object.keys(filesInfo).forEach((item) => {
                        //add to new dictionary
                        updatedFilesInfo = {
                          ...updatedFilesInfo,
                          [item]: {
                            ...filesInfo[item],
                            transform: {
                              ...filesInfo[item].transform,
                              rotate: filesInfo[item].transform.rotate - 90,
                            },
                          },
                        };
                      });

                      //set value
                      setFilesInfo(updatedFilesInfo);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrow-counterclockwise me-2"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
                      />
                      <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Rotate Counter Clockwise
                    </label>
                  </button>
                </div>

                {/* All pages flip button */}
                <div className="d-flex mt-2">
                  <button
                    className="btn btn-outline-primary"
                    onClick={(e) => {
                      //flip all pages
                      //fliph
                      let updatedFilesInfo = {};
                      //iterate dictionary
                      Object.keys(filesInfo).forEach((item) => {
                        //add to new dictionary
                        updatedFilesInfo = {
                          ...updatedFilesInfo,
                          [item]: {
                            ...filesInfo[item],
                            transform: {
                              ...filesInfo[item].transform,
                              flipH:
                                (filesInfo[item].transform.rotate / 90) % 2 ===
                                0 //change flip axis when rotation changed
                                  ? filesInfo[item].transform.flipH
                                    ? false
                                    : true
                                  : filesInfo[item].transform.flipH,
                              flipV:
                                (filesInfo[item].transform.rotate / 90) % 2 !==
                                0 //change flip axis when rotation changed
                                  ? filesInfo[item].transform.flipV
                                    ? false
                                    : true
                                  : filesInfo[item].transform.flipV,
                            },
                          },
                        };
                      });

                      //set value
                      setFilesInfo(updatedFilesInfo);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrows me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L2.707 7.5h10.586l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L13.293 8.5H2.707l1.147 1.146a.5.5 0 0 1-.708.708z" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Flip Horizontal
                    </label>
                  </button>
                  <button
                    className="btn btn-outline-primary ms-2"
                    onClick={(e) => {
                      //flip all pages
                      //flipv
                      let updatedFilesInfo = {};
                      //iterate dictionary
                      Object.keys(filesInfo).forEach((item) => {
                        //add to new dictionary
                        updatedFilesInfo = {
                          ...updatedFilesInfo,
                          [item]: {
                            ...filesInfo[item],
                            transform: {
                              ...filesInfo[item].transform,
                              flipH:
                                (filesInfo[item].transform.rotate / 90) % 2 !==
                                0 //change flip axis when rotation changed
                                  ? filesInfo[item].transform.flipH
                                    ? false
                                    : true
                                  : filesInfo[item].transform.flipH,
                              flipV:
                                (filesInfo[item].transform.rotate / 90) % 2 ===
                                0 //change flip axis when rotation changed
                                  ? filesInfo[item].transform.flipV
                                    ? false
                                    : true
                                  : filesInfo[item].transform.flipV,
                            },
                          },
                        };
                      });

                      //set value
                      setFilesInfo(updatedFilesInfo);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-arrows-vertical me-2"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8.354 14.854a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 13.293V2.707L6.354 3.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 2.707v10.586l1.146-1.147a.5.5 0 0 1 .708.708z" />
                    </svg>
                    <label className="d-none d-sm-none d-md-block">
                      Flip Vertical
                    </label>
                  </button>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isRotating ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //set
                  setIsRotating(true);
                  //watermark image
                  //loop
                  for (let i = 0; i < selectedFiles.length; i++) {
                    //selected file
                    const selectedFile = selectedFiles[i];
                    //key
                    const key = String(selectedFile.path);
                    //check
                    if (key in filesInfo === false) {
                      //continue
                      continue;
                    }

                    //set progress
                    setFilesInfo((prevDictionary) => ({
                      ...prevDictionary,
                      [key]: {
                        ...filesInfo[key],
                        state: AppState.PROCESSING,
                        message: "Rotating image...",
                      },
                    }));

                    //rotate image
                    await rotateFlipImage(
                      selectedFile,
                      {
                        type: filesInfo[key].mimeType,
                        rotate: filesInfo[key].transform.rotate,
                        flipH: filesInfo[key].transform.flipH,
                        flipV: filesInfo[key].transform.flipV,
                      },
                      (blob) => {
                        //set
                        //set blob
                        setFilesInfo((prevDictionary) => ({
                          ...prevDictionary,
                          [key]: {
                            ...filesInfo[key],
                            state: AppState.PROCESSED,
                            message: `Successfully rotated image. Click on download button to save.`,
                            rotated_blob: blob === null ? selectedFile : blob,
                            rotated_size:
                              blob === null ? selectedFile.size : blob.size,
                          },
                        }));
                      },
                    );
                  }
                  //reset
                  setIsRotating(false);
                }}
              >
                TRANSFORM
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FlipImagesListImagesScreen;
